// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__-WRST","form":"Contact_form__JjY-O","msg":"Contact_msg__MsTd5"};